import React, { useEffect } from 'react';
import '../../../styles/mainContents.css'
import { PrintTransfer, fetchInventory, fetchCustomers, fetchTransfers, fetchOrders, fetchTransfernoDetail, fetchSubmitPartialTransfernoDetail, fetchSubmitTransfernoDetail } from '../../../redux/actions/PostActions';
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import { superSearch } from '@codewell/super-search';
import EmptyMuiDataTable from '../../layout/EmptyMuiDataTable';
import { Tooltip, IconButton } from '@mui/material';
import { createTheme, ThemeProvider  } from '@mui/material/styles'
import { Print  } from '@mui/icons-material'

function Transfer(props) {

  //const postState = useSelector(state => state.posts);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleOnClick = () => history.push('localhost:3000/login');

  const { dispatch_Print, fetch_submitPartialTransfernoDetail, fetch_landingPageStates, authreducerState, fetch_transfernoDetail, fetch_transfers, transferState, transferDetailState, transferDetailHeaderState, transferServerResponseState, fetch_submitTransfernoDetail} = props;

  useEffect( () => { 
    // console.log('Transfers useEffect called')
    fetch_transfers(authreducerState.user) 
   
  }, []);

  const columnsTransfers = [
    {
      name: "TRANSFERNO",
      label: "Transfers",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),          
        setCellProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "break-word", 
          padding: "14px 4px 14px 16px",
        }}),         
      },
    },
    {
      name: "FROMLOC",
      label: "From Loc",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),        
      },
    }, 
    {
      name: "TOLOC",
      label: "To Loc",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),        
      },
    },        
    {
      name: "ORDERED",
      label: "Order Date",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"45px", 
          wordWrap: "break-word", 
          padding: "14px 4px 14px 16px",
        }}), 
        customBodyRender: value => {
          return value !== '' ? moment(new Date(value)).format('MM/DD/YYYY') : '';
        },       
      },
    },
    {
        name: "SHIPPED",
        label: "Shipped Date",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => ( {style: {
            maxWidth:"85px", 
            wordWrap: "normal", 
            padding: "14px 4px 14px 16px",
          }}),         
          setCellProps: () => ( {style: {
            maxWidth:"45px", 
            wordWrap: "break-word", 
            padding: "14px 4px 14px 16px",
          }}), 
          customBodyRenderLite: (dataIndex, rowIndex) => { 
            let transfer = transferState[dataIndex]['SHIPPED'] !== '' ? moment(new Date(transferState[dataIndex]['SHIPPED'])).format('MM/DD/YYYY') : ''
            let highlightColumnCN = 'transferHighlightCN';
            if(transfer !== '' && moment(new Date(transferState[dataIndex]['SHIPPED'])).toDate() <= moment(new Date()).subtract(8, 'days').toDate() ) {
              highlightColumnCN = 'transferHighlightAlertCN'
            }
            if(transfer !== '' && moment(new Date(transferState[dataIndex]['SHIPPED'])).toDate() <= moment(new Date().toLocaleDateString()).subtract(5, 'days').toDate() && moment(new Date(transferState[dataIndex]['SHIPPED'])) >= moment(new Date().toLocaleDateString()).subtract(7, 'days').toDate() ) {
              highlightColumnCN = 'transferHighlightCautionCN'
            }

            // console.log(transferState[dataIndex]['TRANSFERNO'],'highlightColumnCN', highlightColumnCN, moment(new Date(transferState[dataIndex]['SHIPPED'])), moment(new Date().toLocaleDateString()).subtract(5, 'days').toDate(), moment(new Date().toLocaleDateString()).subtract(7, 'days').toDate() )
     
            
            return (
              <span>  
                <div className={ highlightColumnCN }>              
                  {transfer}
                </div>                                                                                              
              </span>
            ) 
    
          },           
          // customBodyRender: value => {            
          //   return value !== '' ? moment(new Date(value)).format('MM/DD/YYYY') : '';
          // },         
        },
      },
      {
        name: "MODE",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => ( {style: {
            maxWidth:"85px", 
            wordWrap: "normal", 
            padding: "14px 4px 14px 16px",
          }}),         
          setCellProps: () => ( {style: {
            maxWidth:"30px", 
            wordWrap: "normal",
            padding: "14px 4px 14px 16px",
            textAlign: "center",
          }}),          
        },
      },
      {
        name: "UNIT_COUNT",
        label: "Unit Count",
        options: {
          filter: false,
          sort: true,
          setCellHeaderProps: () => ( {style: {
            maxWidth:"85px", 
            wordWrap: "normal", 
            padding: "14px 4px 14px 16px",
          }}),         
          setCellProps: () => ( {style: {
            maxWidth:"30px", 
            wordWrap: "normal",
            padding: "14px 4px 14px 16px",
            textAlign: "center",
          }}),          
        },
      },                
  ]

  const optionsTransfers = {
    filterType: "checkbox",
    selectableRows: 'none',
    Pagination: false,
    download:false,
    responsive: "standard",
    search: true,
    searchOpen: true,
    //searchAlwaysOpen: true,
    searchPlaceholder: 'SEARCH TRANSFERS',
    // onSearchOpen: () => {
    //   document.getElementById('transfersTblId').getElementsByTagName("input")[0].focus({preventScroll: true})
    //   document.getElementById('transfersTblId').getElementsByTagName("input")[0].select()
    //   // document.getElementById('transfersTblId').getElementsByTagName("input")[0].scrollIntoView()
    //   document.getElementById('transfersTblId').getElementsByTagName("input")[0].autoFocus = true
    //   console.log('TEST Transfer onTableInit: ' + JSON.stringify(document.getElementById('transfersTblId').outerHTML))
    //   console.log('TEST Transfer onTableInit: ' + JSON.stringify(document.getElementById('transfersTblId').getElementsByTagName("input")[0].outerHTML))

    // },       
    onRowClick: (rowData, rowMeta) => {
      console.log(rowData, rowMeta);
      //var custnoInput = rowData[0];
      //console.log('ManageConsignments options_userConsignmentCust custnoInput:' + custnoInput);
      //setCustnoState({ custnoInput: rowData[0] });
      
      //console.log('ManageConsignments custnoState:' + JSON.stringify(custnoState));

      fetch_transfernoDetail(authreducerState.user,rowData[0],rowData[2], rowData[1]);
    },    
    // onTableInit: (action, tableState) => {
    //   tableState.searchProps.autoFocus =  false
    //   //tableState.searchText = 'TEST'
      
    //   console.log('TEST Transfer onTableInit: ' + JSON.stringify(tableState))
    // }, 
    onSearchOpen: () => {
      // console.log('TEST Transfer onSearchOpen: ' + JSON.stringify('tes'))
      // document.getElementById('transfersTblId').getElementsByTagName("input")[0].focus({preventScroll: true})
      // document.getElementById('transfersTblId').getElementsByTagName("input")[0].select()
      // // document.getElementById('transfersTblId').getElementsByTagName("input")[0].scrollIntoView()
      // document.getElementById('transfersTblId').getElementsByTagName("input")[0].autoFocus = true
      // console.log('TEST Transfer onTableInit: ' + JSON.stringify(document.getElementById('transfersTblId').outerHTML))
      // console.log('TEST Transfer onTableInit: ' + JSON.stringify(document.getElementById('transfersTblId').getElementsByTagName("input")[0].outerHTML))
        
    },       
    searchProps: {
      autoFocus: false,

      // onClose: (window, e) => {
      //   console.log('TEST Transfer onLoadStart: ' + JSON.stringify(document.getElementById('transfersTblId').getElementsByTagName("input")[0].outerHTML))

      // },
      onKeyUp:(e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {          
          var rowsCounter = 0;
          var transferno = null;
          var toloc = null;
          var fromloc = null;

          transferState.reduce( (previousValue, currentValue, currentIndex, array) => {          
            if(rowsCounter > 1){
              return null;
            }

            if(superSearch()(e.target.value, {...currentValue}).numberOfMatches>0){
              transferno = currentValue['TRANSFERNO']
              toloc = currentValue['TOLOC']
              fromloc = currentValue['FROMLOC']

              rowsCounter++
            }

            return rowsCounter;
          }, 0)

          if(rowsCounter === 1){
            fetch_transfernoDetail(authreducerState.user,transferno,toloc,fromloc);
          }
        }
        else if (e.key === 'Tab' || e.keyCode === 9) {
          console.log('Transfer tab called')
        }
      }
    },      
    rowsPerPage: 10,  
  };

  const columnsOptions_transfernoDetail = (colName='', inputType='number',filterEnabled=true) => {
    var options = {};
    let maxValue = 1000;

    options = {
      filter: filterEnabled,
      sort: true, 
      download:false, 
      customBodyRenderLite: (dataIndex, rowIndex) => {
        let newTransfernoDetailState = [...transferDetailState]   
        
        if(colName === 'USER_INPUT_QTY'){
          return (
            <span>              
              {
              (authreducerState.user.role_name === undefined) ? "" :                    
              (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" 
              :
                            
                transferDetailHeaderState['USER_TRANSFER_PERMISSIONID'] > 1 ? 
                ( 
                  <React.Fragment></React.Fragment> 
                ) 
                : 
                (
                  <React.Fragment>                                    
                    {transferDetailHeaderState['USER_TRANSFER_PERMISSIONID'] <= 1 && (transferDetailState[0]['MODE'] === 'S' || transferDetailState[0]['MODE'] === 'R') ? (
                      <input 
                        id={'iTransferDetailInputIndex' + dataIndex + '-' + rowIndex} 
                        type={inputType} 
                        name={'nTransferDetailInputIndex' + dataIndex + '-' + rowIndex}
                        key={dataIndex + '-' + rowIndex}
                        min="0"
                      
                        defaultValue={newTransfernoDetailState[dataIndex][colName] === null ? 0 : newTransfernoDetailState[dataIndex][colName]}
                        onInput={(e) => {
                          var min = e.target.min
                          var max = newTransfernoDetailState[dataIndex]['TRANSFERQTY']
                          var val = parseInt(e.target.value) || (min - 1); // if input char is not a number the value will be (min - 1) so first condition will be true
                          if (val < min){
                            newTransfernoDetailState[dataIndex][colName] = min
                            e.target.value = min
                          }
                          else if (val > max){
                            alert('Unable to receive a qty greater than the transfer qty.  If you have more parts than the transfer qty, please contact directshippartner@fmpco.com for help.')

                            newTransfernoDetailState[dataIndex][colName] = max 
                            e.target.value = max 
                          }                       
                          else 
                            newTransfernoDetailState[dataIndex][colName] = e.target.value
                        }}                        
                      />
                    ) 
                    : ''                      
                    }                                                                                            
                  </React.Fragment>
                )
              }
            </span>
          )
        }
        else{
          return (
            <span>  
              <React.Fragment>              
                {newTransfernoDetailState[dataIndex][colName]}  
              </React.Fragment>                                                                                  
            </span>
          )
        }
        
      }            
    }
    return options;
  }

  const columnsTransfernoDetail = () => {
    if(authreducerState.user.role_name === undefined || 
      (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR'))  
    {
      return [
        {
          name: "LINE",
          label: "Line",
          options: columnsOptions_transfernoDetail('LINE','text',true),
        },
        {
          name: "PARTNO",
          label: "Partno",
          options: columnsOptions_transfernoDetail('PARTNO','text',true),
        },
        {
          name: "DESCRIPTION",
          label: "DESCRIPTION",
          options: columnsOptions_transfernoDetail('DESCRIPTION','text',true),
        },        
        {
          name: "DISPLAYEDBIN",
          label: "BIN",
          options: columnsOptions_transfernoDetail('DISPLAYEDBIN','text',true),
        },        
        {
          name: "TRANSFERQTY",
          label: "Transfer Qty",
          options: columnsOptions_transfernoDetail('TRANSFERQTY','number',false),
        }     
      ]  
    }
    else if(transferDetailHeaderState['USER_TRANSFER_PERMISSIONID'] <= 1 && (transferDetailState[0]['MODE'] === 'S' || transferDetailState[0]['MODE'] === 'R')){
      return [
        {
          name: "LINE",
          label: "Line",
          options: columnsOptions_transfernoDetail('LINE','text',true),
        },
        {
          name: "PARTNO",
          label: "Partno",
          options: columnsOptions_transfernoDetail('PARTNO','text',true),
        },
        {
          name: "DESCRIPTION",
          label: "DESC",
          options: columnsOptions_transfernoDetail('DESCRIPTION','text',true),
        },        
        {
          name: "DISPLAYEDBIN",
          label: "BIN",
          options: columnsOptions_transfernoDetail('DISPLAYEDBIN','text',true),
        },             
        {
          name: "TRANSFERQTY",
          label: "Transfer Qty",
          options: columnsOptions_transfernoDetail('TRANSFERQTY','number',false),
        },
        {
          name: "USER_INPUT_QTY",
          label: "Received Qty",
          options: columnsOptions_transfernoDetail('USER_INPUT_QTY','number',false)
        }        
      ]
    }
    else{
      return [
        {
          name: "LINE",
          label: "Line",
          options: columnsOptions_transfernoDetail('LINE','text',true),
        },
        {
          name: "PARTNO",
          label: "Partno",
          options: columnsOptions_transfernoDetail('PARTNO','text',true),
        },
        {
          name: "DESCRIPTION",
          label: "DESC",
          options: columnsOptions_transfernoDetail('DESCRIPTION','text',true),
        },        
        {
          name: "DISPLAYEDBIN",
          label: "BIN",
          options: columnsOptions_transfernoDetail('DISPLAYEDBIN','text',true),
        },             
        {
          name: "TRANSFERQTY",
          label: "Transfer Qty",
          options: columnsOptions_transfernoDetail('TRANSFERQTY','number',false),
        }     
      ]      
    }
  }


  const PrintButton = () => (
    <Tooltip disableFocusListener title="Print">
      <IconButton onClick={() => dispatch_Print()}>
        <Print />
      </IconButton>
    </Tooltip>
  );

  const HeaderElements = () => (
    <>
      <PrintButton />
    </>
  );

  const optionsTransfernoDetailTbl = {
    filterType: "checkbox",
    selectableRows: 'none',
    print: false,
    customToolbar: () => (<HeaderElements />),
    Pagination: true,
    responsive: "standard",
    onRowClick: (rowData, rowMeta) => {
      console.log("Transfer optionsTransfernoDetailTbl onRowClick rowData:" + JSON.stringify(rowData) + " rowMeta:" + JSON.stringify(rowMeta));
    },
    // onColumnSortChange: (changedColumn, directions) => {
    //   console.log("Transfer optionsTransfernoDetailTbl onColumnSortChange changedColumn:" + JSON.stringify(changedColumn) + " directions:" + JSON.stringify(directions));

    // },
    // onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      
    //   const result = rowsSelected.map(item => {
    //     console.log("Transfer optionsTransfernoDetailTbl onRowSelectionChange item:" + item);
    //     return transferDetailState[item];
    //   });
    //   const selectedPrdids = result.map(item => {
    //     return item.PRDID;
    //   });
    //   console.log("Transfer selectedPrdids:" + selectedPrdids);

    // },    
    onChangePage (currentPage) {
      console.log({currentPage});     
    },
    rowsPerPage: 200,
  };  


  return (

    <div >
        <div>           
          <div id='transfersTblId' className='landingPageTblClass'>
            {/* {console.log('Transfers transferState:' + JSON.stringify(transferState))} */}
            { transferState !== undefined && transferState !== null ?
                transferState.length === 0 ?
                <div>
                  Note: Transfers list updated once nightly
                  <EmptyMuiDataTable title={'No Transfers'}/> 
                </div>                  
                      
                :  
                <div>
                  Note: Transfers list updated once nightly                              
                  <MUIDataTable
                    title={"Transfers"}
                    data={transferState}
                    columns={columnsTransfers}
                    options={optionsTransfers}                 
                    />    
                </div>                                         
              : 
              ''                                       
            }

          </div>

          <div id='transfernoTblId' className='detailTblClass'>
    
            { transferDetailState !== undefined && 
                transferDetailState !== null ?
                  transferDetailState.length > 0 ?
                    <div>

                      <MUIDataTable
                        title={
                          <table id='transfernoDetailTblHeader'>
                            <thead>
                              <tr>
                                <th colSpan='4'>Transferno Detail {transferDetailHeaderState['TRANSFERNO']}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td colSpan={'4'}>Status: {transferDetailHeaderState['IS_TRANSFER_PARTIAL'] === false ? 'NEW' : 'PARTIAL TRANSFER'}</td>
                              </tr>
                              <tr>
                                {/* <td>Transferno: {transferDetailHeaderState['TRANSFERNO']}</td> */}
                                <td>Shipped From:</td>
                                <td>
                                  {transferDetailHeaderState['FROM_NAME']}
                                  <br/>
                                  {transferDetailHeaderState['FROM_ADDR1']}
                                  <br/>
                                  {transferDetailHeaderState['FROM_CITY'] + ','+ transferDetailHeaderState['FROM_STATE'] + transferDetailHeaderState['FROM_ZIP']}
                                </td>
                                <td>Shipped To:</td>
                                <td>
                                  {transferDetailHeaderState['TO_NAME']}
                                  <br/>
                                  {transferDetailHeaderState['TO_ADDR1']}
                                  <br/>
                                  {transferDetailHeaderState['TO_CITY'] + ','+ transferDetailHeaderState['TO_STATE'] + transferDetailHeaderState['TO_ZIP']}
                                </td>                        
                              </tr>
                            
                            </tbody>
                          </table>
                        }
                        data={transferDetailState}
                        columns={columnsTransfernoDetail()}
                        options={optionsTransfernoDetailTbl}
                      />

                      <div id="buttonsTransferDetail">

                        <button type='button' id='backToTransfernos' onClick={()=>{window.location.href='/'}}>Back</button>

                        {
                        (authreducerState.user.role_name === undefined) ? "" :                    
                        (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" 
                        :                                                                        
                          transferDetailHeaderState['USER_TRANSFER_PERMISSIONID'] <= 1 && (transferDetailState[0]['MODE'] === 'S' || transferDetailState[0]['MODE'] === 'R') ? (
                            transferServerResponseState !== undefined && transferServerResponseState !== null &&
                            Object.keys(transferServerResponseState).length > 0 &&
                            transferServerResponseState['SUCCESSFUL_UPDATES'] !== '' ?
                              <React.Fragment>
                                {fetch_landingPageStates(authreducerState.user)}
                              </React.Fragment>
                            :                      
                            <span>
                              <button type='button' id='submitPartialTransfernoDetail' 
                                  title='Keep transfer open/multiple shipments/partial transfer'
                                  onClick={(e)=>{ 
                                if (window.confirm('Click Ok to submit partial transfer and keep transfer open or click Cancel to not submit partial transfer.')) 
                                {
                                  fetch_submitPartialTransfernoDetail(authreducerState.user, transferDetailHeaderState, transferDetailState)
                                }
                              }}>Partial Submit - Expecting Future Shipment</button>


                              <button type='button' id='submitCompletedTransfernoDetail' 
                                title='Submit transfer shipment'
                                onClick={(e)=>{ 
                                if (window.confirm('Click Ok to submit complete transfer or Cancel to not submit complete transfer.')) 
                                {
                                  //fetch_submitTransfernoDetail(transferDetailState)
                                  fetch_submitTransfernoDetail(authreducerState.user, transferDetailHeaderState, transferDetailState)

                                }
                              }}>Complete Submit</button>
                            </span> 
                            ) 
                            : '' 
                        }
                      </div>
                    </div>

                    : ''               
              : ''
            }

          </div>

          
        </div>
    </div>

  );
}


const mapStateToProps = (state) => {
 return {
   transferState: state.transfer['items_fetchTransfers'],
   transferDetailState: state.transfer['items_fetchTransfernoDetail'],
   transferDetailHeaderState: state.transfer['items_fetchTransfernoDetailHeader'],   
   transferServerResponseState: state.statusUpdateReducer['transferServerResponse'],
   authreducerState: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_landingPageStates: (user) => {
      dispatch(fetchOrders(user));
      dispatch(fetchTransfers(user));
      dispatch(fetchCustomers(user));
      dispatch(fetchInventory(user));
    },         
    fetch_transfers: (user) => {
      dispatch(fetchTransfers(user));
    },
    fetch_transfernoDetail: (user, transferno, toloc, fromloc) => {
      dispatch(fetchTransfernoDetail(user, transferno, toloc, fromloc));
    },     
    fetch_submitPartialTransfernoDetail: (user, headerState, detailState) => {
      dispatch(fetchSubmitPartialTransfernoDetail(user, headerState, detailState));
    },
    fetch_submitTransfernoDetail: (user, headerState, detailState) => {
      dispatch(fetchSubmitTransfernoDetail(user, headerState, detailState));
    }, 
    dispatch_Print: () => {
      dispatch(PrintTransfer());
    },         
    fetch_submitTransfernoDetailOLD: (state) => {
      dispatch(fetchSubmitTransfernoDetail(state));
    }        
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Transfer);